<template>
  <div class="outerbox intTet">
    <div class="innercoreversion intTetcont">
      <div class="leftboxnowtext">
        <div class="titleintei">
          {{ showtext[active] }}
          <div class="lineunder"></div>
        </div>

        <div class="texttitleinte">
          <div v-if="active == 0">
            通过监控系统结合AI能力，对企业的检查标准进行远程巡检，跟进整改进度。并进行考核打分，<span
              style="color: #52d49c"
              >提高人效实现低成本的高效管理。</span
            >
          </div>
          <div v-if="active == 1"><span style="color: #52d49c">事前管控，AI进度识别，</span>质量管理，多人直播验收</div>
          <div v-if="active == 2">
            设备接入，<span style="color: #52d49c">支持门店营运相关设备的接入</span
            >，如空调，新风，热水，外招，灯光，排烟，烤箱，炸锅等，把传统设备通过智能控制升级为智能设备。消防系统，将网关接入门店消防总线即可实现消防设备的联动，实现远程报警。同样支持市面9成以上消防品牌，如海湾，松江，三江，霍尼韦尔，北大青鸟等
          </div>
          <div v-if="active == 3">
            亚朵酒店，能源智能管控；滴灌通充电桩，营运监测、能源管控；无人贩卖机，营运监测、能源管控；大金空调，AI控温；
          </div>
        </div>
        <div class="titletwoleft animate__backInUp">
          <div class="boxtetejianj" v-for="(item, index) in textall[active].arrtitle" :key="index">
            <div v-for="(ite, inde) in item.conten" :key="inde">
              <img
                src="../image/yes.png"
                style="vertical-align: text-bottom; margin-right: 10px;transform: translateY(-3px);"
                width="16px"
                height="16px"
                alt=""
              />
              <span>{{ ite.title }}</span>
            </div>
          </div>
          <!-- <div class="boxtetejianj">
          <div>
            <img
              src="../image/yes.png"
              style="vertical-align: text-bottom; margin-right: 10px"
              width="16px"
              height="16px"
              alt=""
            />
            <span>AI巡检、时实巡检、线下巡检</span>
          </div>
          <div>
            <img
              src="../image/yes.png"
              style="vertical-align: text-bottom; margin-right: 10px"
              width="16px"
              height="16px"
              alt=""
            />
            <span>训练中心</span>
          </div>
          <div>
            <img
              src="../image/yes.png"
              style="vertical-align: text-bottom; margin-right: 10px"
              width="16px"
              height="16px"
              alt=""
            />
            <span>客流分析</span>
          </div>
          <div>
            <img
              src="../image/yes.png"
              style="vertical-align: text-bottom; margin-right: 10px"
              width="16px"
              height="16px"
              alt=""
            />
            <span>总部大屏</span>
          </div>
          <div>
            <img
              src="../image/yes.png"
              style="vertical-align: text-bottom; margin-right: 10px"
              width="16px"
              height="16px"
              alt=""
            />
            <span>模范门店招商示例</span>
          </div>
        </div> -->
        </div>
      </div>
      <div class="rightwidt" ref="imganimate">
        <!-- animate__slower -->
        <img
          v-if="shownimate"
          class="imgposition"
          :class="shownimate ? 'animate__animated animate__backInUp' : ''"
          :src="textall[active].imageutl"
          alt=""
        />
      </div>
      <!-- <img class="imgposition animate__animated animate__pulse" :src="textall[active].imageutl" alt="" /> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'intTet',
  props: {
    textall: Array,
    active: Number,
  },
  watch: {
    active(nowdata, oldedata) {
      console.log(this.shownimate, '值替换', nowdata, oldedata)
      this.shownimate = false
      // this.$nextTick(() => {
      setTimeout(() => {
        this.shownimate = true
      }, 100)
      // })
    },
  },
  data() {
    return {
      shownimate: false,
      showtext: ['智能巡检', '智能营建', '智能设备', 'AI场景搭建'],
    }
  },
  mounted() {
    const target = this.$refs.imganimate
    // 创建 IntersectionObserver
    this.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.shownimate = true
          console.log('盒子进入可视区间')
        } else {
          this.shownimate = false
          // this.observer.disconnect()
          console.log('盒子离开可视区间')
        }
      })
    })

    // 开始监听
    this.observer.observe(target)
  },
  beforeDestroy() {
    // 停止观察以防止内存泄漏
    if (this.observer) {
      this.observer.disconnect()
    }
  },
  methods: {},
}
</script>

<style lang="less">
.intTet {
  height: 582px;
  background: #293853;
  .intTetcont {
    position: relative;
    height: 100%;
    color: #fff;
    padding: 106px 0 162px 0;
    // display: flex;
    // flex-direction: column;
    // justify-content: space-between;
    display: flex;
    .leftboxnowtext {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .titleintei {
        font-weight: 500;
        font-size: 24px;
        color: #ffffff;
        margin-bottom: 16px;
        .lineunder {
          margin-top: 12px;
          width: 100px;
          height: 2px;
          background: #ffffff;
        }
      }
      .texttitleinte {
        max-width: 534px;
        font-weight: 300;
        font-size: 16px;
        color: #ffffff;
        line-height: 34px;
        margin-bottom: 12px;
      }
      .titletwoleft {
        // width: 50%;
        flex: 1;
        display: flex;
        // justify-content: space-between;
        .boxtetejianj {
          font-weight: 300;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          margin-right: 30px;
        }
      }
    }
    .rightwidt {
      width: 556px;
      flex: 1;
    }
    .imgposition {
      // width: 556px;
      height: 640px;
      // z-index: 2;
      position: absolute;
      top: -42px;
      right: 0;
    }
  }
}
</style>